'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var List = require('./list')
var EditNew = require('./edit-new')
// var Schedule = require('./schedule')

// var ShowController = require('./show')

var GroupsModule = function () {
  var Router = App.PermissionAppRouter.extend({
    appRoutes: {
    }
  })

  //
  var API = {
    list: function (options) {
      new List(options)
    },
    edit: function (options) {
      new EditNew(options)
    }
  }

  App.globalChannel.on('group:edit', function (options) {
    API.edit(options)
  })
  App.globalChannel.on('group:new', function (options) {
    API.edit(options)
  })
  App.globalChannel.on('groups:list', function (options) {
    API.list(options)
  })

  // App.vent.on "crew:member:clicked crew:created", (member) ->
  //   App.navigate Routes.edit_crew_path(member.id)
  //   API.edit member.id, member

  // fire this up on an global app event
  new Router({ controller: API })
}

module.exports = GroupsModule



// WEBPACK FOOTER //
// ./js/modules/groups/index.js